import React from "react";

import { useHistory } from "react-router-dom";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";

export default function Character({ data }) {
  const history = useHistory(); //habilitar history para redirecciones
  const onClick = (id) => {
    history.push(`char-detail/${id}`);
  };
  return (
    <Card
      sx={{ maxWidth: 345 }}
      style={{
        borderRadius: "15px 50px",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "secondary.main",
          opacity: [0.9, 0.8, 0.7],
        },
      }}
      variant="outlined"
    >
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
      >
        <img
          style={{ width: 120, height: 60 }}
          alt="rarityIcons"
          src={data.rarity.icon}
        />
      </Stack>

      <CardMedia
        component="img"
        style={{
          maxHeight: "200px",
          maxWeight: "200px",
          minHeight: "200px",
          borderRadius: 10,
        }}
        image={data.image}
        alt="charIcon"
        onClick={() => onClick(data._id)}
      />
      <CardContent>
        {data.name.length > 6 ? (
          <Typography variant="h6" align="center">
            {data.name}
          </Typography>
        ) : (
          <Typography variant="h5" align="center">
            {data.name}
          </Typography>
        )}

        <Divider style={{ marginTop: 1, marginBottom: 5 }} />
        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          alignItems="center"
        >
          <Tooltip title={data.clas.name}>
            <Avatar
              style={{ width: 60, height: 60 }}
              variant="square"
              alt="rarityIcons"
              src={data.clas.icon}
            />
          </Tooltip>
          <Tooltip title={data.type.name}>
            <Avatar
              style={{ width: 60, height: 60 }}
              variant="square"
              alt="rarityIcons"
              src={data.type.icon}
            />
          </Tooltip>
        </Stack>
      </CardContent>
    </Card>
  );
}
